import { t } from 'i18next';
import PrintIcon from '../../../../../assets/images/export-print-icon.svg';
import { BaseSelector, SelectorProps } from './BaseSelector';

export const PrintSelector = ({ selected, loading, disabled, disabledReason, description, onSelected }: SelectorProps) => {
  return (
    <BaseSelector
      title={t('print')}
      description={description}
      icon={<PrintIcon aria-hidden="true" width="40" height="40" />}
      selected={selected}
      onSelected={onSelected}
      loading={loading ?? false}
      disabled={disabled ?? false}
      disabledReason={disabledReason}
    />
  );
};
